export default [
  {
    categoria: "Rodamientos Industriales",
    productos: [
      {
        nombre: "Axiales de bolas y agujas",
        slug: "axiales-de-bolas-y-agujas",
        imagen: require("@/assets/images/productos-industrial/rodamientos-industriales/axiales-de-bolas-y-agujas.webp"),
      },
      {
        nombre: "Axiales de rodillos cilíndricos",
        slug: "axiales-de-rodillos-cilindricos",
        imagen: require("@/assets/images/productos-industrial/rodamientos-industriales/axiales-de-rodillos-cilindricos.webp"),
      },
      {
        nombre: "Contacto angular",
        slug: "contacto-angular",
        imagen: require("@/assets/images/productos-industrial/rodamientos-industriales/contacto-angular.webp"),
      },
      {
        nombre: "De agujas Industrial",
        slug: "de-agujas-industrial",
        imagen: require("@/assets/images/productos-industrial/rodamientos-industriales/de-agujas-industrial.webp"),
      },
      {
        nombre: "Rígido de bolas Industrial",
        slug: "rigido-de-bolas-industrial",
        imagen: require("@/assets/images/productos-industrial/rodamientos-industriales/rigido-de-bolas-industrial.webp"),
      },
      {
        nombre: "Rodillos a rótula",
        slug: "rodillos-a-rotula",
        imagen: require("@/assets/images/productos-industrial/rodamientos-industriales/rodillos-a-rotula.webp"),
      },
      {
        nombre: "Rodillos cilindricos Industrial",
        slug: "rodillos-cilindricos-industrial",
        imagen: require("@/assets/images/productos-industrial/rodamientos-industriales/rodillos-cilindricos-industrial.webp"),
      },
      {
        nombre: "Rodillos Cónicos Industrial",
        slug: "rodillos-conicos-industrial",
        imagen: require("@/assets/images/productos-industrial/rodamientos-industriales/rodillos-conicos-industrial.webp"),
      },
    ],
  },
  {
    categoria: "Rodamientos Autocentrantes Industriales",
    productos: [
      {
        nombre: "Línea Industrial",
        slug: "linea-industrial",
        imagen: require("@/assets/images/productos-industrial/rodamientos-autocentrantes/linea-industrial.webp"),
      },
    ],
  },
];
